export default "__VITE_ASSET__CxFcAzKS__"